package amazon.lastmile.inject

import app.nestbridge.app.ui.OtpVerificationUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = OtpVerificationUiFactory::class)
public interface AppNestbridgeAppUiOtpVerificationUiFactory {
  @Provides
  @IntoSet
  public fun provideOtpVerificationUiFactoryFactoryMultibinding(otpVerificationUiFactory: OtpVerificationUiFactory): Ui.Factory = otpVerificationUiFactory
}
